import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../../shared/services/auth.service";
import {FilterService} from "../../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, first, takeUntil} from "rxjs/operators";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {HttpErrorResponse} from "@angular/common/http";
import {getCurrentRouteState} from "../../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../../shared/ngrx/route-serializer";
import {Sort} from "@angular/material/sort";
import {ReceivablesBalance} from "../../../../shared/interface/receivables-balance";
import {ReceivablesBalanceService} from "../../../../shared/services/receivables-balance.service";
import {JobResultDialogComponent} from "../../../../shared/components/job-result-dialog/job-result-dialog.component";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {
  OfwcaChangeAccountNumberDialogComponent
} from "../../../ofwcas/ofwca-change-account-number-dialog/ofwca-change-account-number-dialog.component";
import {
  ReceivablesBalanceAddDialogComponent
} from "../receivables-balance-add-dialog/receivables-balance-add-dialog.component";
import {COMMISSION_IMPORT_ROW_STATUS_ASSIGNED} from "../../../../shared/services/dict.service";


@Component({
  selector: 'app-all-receivables-balance-list',
  templateUrl: './all-receivables-balance-list.component.html',
  styleUrls: ['./all-receivables-balance-list.component.scss']
})
export class AllReceivablesBalanceListComponent implements  AfterViewInit, OnInit, OnDestroy  {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() structure?: string = null;
  @Input() showFilter = true;
  @Input() partnerId?: string = null;
  @Input() displayedColumns: string[] = [ 'partner', 'regional', 'sum', 'namber', 'active'];
  @Input() embeddedView = false;


  initialFilters: any;
  rows: ReceivablesBalance[] = [];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  sortBy = '';
  sortOrder = '';
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
    private receivablesBalanceService: ReceivablesBalanceService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.receivablesBalanceService.rowListSubject
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      ).subscribe({
      next: (response: CountedAndPaginated<ReceivablesBalance>) => {
        this.rows = response.items;
        this.totalData = response.pagination.total;
      },
      error: (response: HttpErrorResponse) => {
        this.snack.open('Przy ładowaniu danych wystąpił błąd', response.status.toString(), {duration: 2000});
      }
    });
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      partner: 'string',
      ofwca: 'string',
      contains$recordId: 'string',
      sumAmountDueFrom: 'string',
      sumAmountDueTo: 'string',
      active: 'int',
      owner: 'int'
      // statementSumFrom: 'string',
      // statementSumTo: 'string',
    }, filters);
  }

  ngAfterViewInit(): void {
    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.structure = this.structure ?? data.structure ?? null;
        this.displayedColumns = data.displayedColumns ?? this.displayedColumns;
        if (!this.embeddedView) {
        this.store
          .pipe(
            select(getCurrentRouteState),
            delay(0),
            distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
            takeUntil(this.destroyed$),
          )
          .subscribe((state: RouterStateUrl) => {
            this.parseFilters(state.params);
            this.paginator.pageIndex = state.params.page;
            this.paginator.pageSize = state.params.pageSize;
            this.loadListData();
          });
        } else {
          this.loadListData();
        }
      });

    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      if (this.embeddedView) {
        this.loadListData();
      } else {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: event.pageIndex,
          pageSize: event.pageSize,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          ...this.filtersForm.value
        })]);
      }
    });

  }

  ngOnInit(): void {
  }

  sortChanged($event: Sort): void {
    this.sortBy = $event.active;
    this.sortOrder = $event.direction;

    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      sortBy: $event.active,
      sortOrder: $event.direction,
      page: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value
    })]);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (null !== this.partnerId) {
      filters.partnerId = this.partnerId;
    }

    return filters;
  }

  async loadListData():  Promise<void>  {
    this.receivablesBalanceService.loadList(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFilters(),
      this.structure,
    {
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      });
  }

  filter(): void {
    if (this.embeddedView) {
      if (this.paginator.pageIndex === 0) {
        this.loadListData();
      } else {
        this.paginator.firstPage();
      }
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: this.paginator.pageSize,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
        ...this.filtersForm.value,
      })]);
    }
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    if (this.embeddedView) {
      this.loadListData();
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
        page: 0,
        pageSize: this.paginator.pageSize,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
      }]);
    }
  }

  downloadReport(): void {
    this.receivablesBalanceService.downloadReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  add(): void {
    const dialogRef = this.dialog.open(ReceivablesBalanceAddDialogComponent, {
      width: '700px',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadListData();
    });
  }

}
